import { Box } from "@mui/material";

import {
  useCompanyHasPaymentMethod,
  useRoleContext,
  useSubscriptionStatus,
} from "hooks";

interface Props {
  enableWithSubscriptionPlan: SubscriptionPlan;
  noPaymentMethodComponent: React.ReactNode;
  children: React.ReactNode;
}

export function PaymentMethodRequiredWrapper(props: Props): JSX.Element {
  const { enableWithSubscriptionPlan, children, noPaymentMethodComponent } =
    props;
  const { subscription } = useSubscriptionStatus();
  const { company } = useRoleContext();

  const isOnPlanRequiringPaymentMethod =
    subscription?.subscription_plan === enableWithSubscriptionPlan;

  const {
    hasPaymentMethod,
    loading: loadingHasPayment,
    error: hasPaymentError,
  } = useCompanyHasPaymentMethod({
    companyId: company?.id ?? null,
    enabled: isOnPlanRequiringPaymentMethod,
  });

  // Strictly false rather than falsy: the hook reports null both before the lookup
  // resolves and while the company is still absent, and a null URL means SWR never
  // reports loading. A loose check gates the quote form on a lookup that never ran.
  if (
    isOnPlanRequiringPaymentMethod &&
    hasPaymentMethod === false &&
    hasPaymentError == null &&
    !loadingHasPayment
  ) {
    return <Box>{noPaymentMethodComponent}</Box>;
  }
  return <Box>{children}</Box>;
}
